// Generation gate shared by loadable media. Native load/error events cannot be aborted, so a
// replacement source invalidates the old ticket and only the exact current source may settle.
export class ResourceLoadState {
  constructor({ onLoading = () => {}, onReady = () => {}, onFailure = () => {} } = {}) {
    this.onLoading = onLoading
    this.onReady = onReady
    this.onFailure = onFailure
    this.generation = 0
    this.pending = false
    this.source = null
  }

  start(source) {
    this.generation += 1
    this.pending = true
    this.source = source || null
    this.onLoading()
    return this.generation
  }

  ready(generation, source) {
    if (!this.#current(generation, source)) return false

    this.pending = false
    this.onReady()
    return true
  }

  fail(generation, source) {
    if (!this.#current(generation, source)) return false

    this.pending = false
    this.onFailure()
    return true
  }

  cancel() {
    this.generation += 1
    this.pending = false
    this.source = null
  }

  #current(generation, source) {
    return this.pending && generation === this.generation && (source || null) === this.source
  }
}
